module.exports = __webpack_public_path__ + "static/media/bg.fe5e93a4.png";